import React from 'react';
import {
  Grid, Typography, Paper, IconButton, Breadcrumbs, Dialog,
  DialogTitle, DialogActions, DialogContent, TextField, Button, Menu, MenuItem, Collapse, ListItemText, ListItem, ListItemIcon
} from '@material-ui/core';
import {
  Folder, ExpandLess, ExpandMore, Delete, InsertDriveFile, Clear,
} from '@material-ui/icons';

import HomeIcon from '@mui/icons-material/Home';

import MoreVertIcon from '@mui/icons-material/MoreVert';

import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import PreviewModal from "./PreviewModal";
import {ContentCopy, DriveFileRenameOutline, FileUpload} from "@mui/icons-material";
import CustomToolbar from "../global/CustomToolbar";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";

import UploadFileDialog from './UploadFileDialog';
import {BASE_URL, FOLDER} from "../global/Server/endpoints";
import {apiRequest} from "../../redux/actions/api";
import DownloadIcon from '@mui/icons-material/Download';
import FeedbackBar from "../feedbackBar/FeedbackBar";
import {userInfoSelector} from "../../redux/selectors/auth";
import withShipment from "../../withShipment";
import InputAdornment from "@material-ui/core/InputAdornment";
import RecyclingIcon from '@mui/icons-material/Recycling';
import RecycleBin from "./RecycleBin";

class FileManager extends React.Component {
  constructor(props) {
    super(props);

    const parentId = props.location?.state?.parentId;
    const selectedFolder =
      props.location?.state?.selectedFolder || 'Real Estate';

    this.state = {
      parentId: parentId,
      selectedFolder,
      rootFolder: selectedFolder,
      currentPath: [],
      fileStructure: { [selectedFolder]: null },
      folderHistory: [[]],
      historyIndex: 0,
      contextMenuAnchor: null,
      contextMenuTarget: null,
      showFolderDialog: false,
      newFolderName: '',
      expandedFolders: [],
      previewOpen: false,
      selectedFile: null,
      clipboardAction: null,
      clipboardItem: null,
      contextMenuPosition: null,
      contextGridMenuAnchor: null,
      showUploadDialog: false,
      newFiles: [],
      deleteId: null,
      feedbackBarOpen: false,
      feedbackStatus: '',
      feedbackMessage: '',
      searchText: '',
      searchResults: [],
      showRecycleBin: false,
      recycleBinFiles: [],
      renameTarget: null,
    };
  }

  async componentDidMount() {
    await this.loadContents();
  }

  handleGlobalSearch = () => {
    const { searchText } = this.state;

    if (!searchText || searchText.trim().length < 2) {
      this.setState({ searchResults: [] });
      return;
    }

    this.props.apiRequest({
      key: 'fileManager/globalSearch',
      endpoint: FOLDER.GLOBAL_SEARCH,
      data: { query: searchText.trim(), parentId: this.state.parentId },
      silent: true,
      onSuccess: (payload) => {
        if (payload?.success) {
          this.setState({ searchResults: payload.results });
        }
      },
    });
  };

  openFeedbackBar = (status, message) => {
    this.setState({
      feedbackStatus: status,
      feedbackMessage: message,
      feedbackBarOpen: true,
    });
  };

  closeFeedbackBar = () => {
    this.setState(
      { feedbackBarOpen: false, feedbackStatus: '', feedbackMessage: '' },
      () => {}
    );
  };

  handleFolderDialogConfirm = async () => {
    const { newFolderName, renameTarget } = this.state;
    const name = newFolderName.trim();
    if (!name) return;

    if (renameTarget) {
      // Renaming
      await this.renameNode(renameTarget.fileNodeId, name);
    } else {
      // Creating folder
      await this.handleCreateFolder(); // Keep your existing function
    }

    // Reset dialog
    this.setState({
      showFolderDialog: false,
      newFolderName: '',
      renameTarget: null,
    });
  };

  openRenameDialog = (item) => {
    this.setState({
      showFolderDialog: true,
      newFolderName: item.name, // pre-fill with current name
      renameTarget: item,
      contextMenuAnchor: null,
      contextGridMenuAnchor: null,
      contextMenuTarget: null,
    });
  };

  handleFileClick = (fileObj) => {
    const fileExtension = fileObj.name.split('.').pop().toLowerCase();
    let type = '';
    if (['png', 'jpg', 'jpeg', 'gif'].includes(fileExtension)) {
      type = 'image';
    } else if (fileExtension === 'pdf') {
      type = 'application/pdf';
    }

    this.setState({
      selectedFile: {
        name: fileObj.name,
        url: fileObj.url,
        type: type,
        path: fileObj.path,
      },
      previewOpen: true,
    });
  };

  handleClosePreview = () => {
    this.setState({ previewOpen: false, selectedFile: null });
  };

  buildTree = (allItems = [], parentId) => {
    const filteredItems = allItems.filter((item) => {
      if (!item) {
        console.warn('Skipping null or undefined item in buildTree');
        return false;
      }

      return item.parentId === parentId;
    });

    return filteredItems.reduce((acc, item) => {
      acc[item.name] = {
        ...item,
        children: this.buildTree(allItems, item.fileNodeId), // Recurse with allItems
      };
      return acc;
    }, {});
  };

  goBack = () => {
    const { currentPath } = this.state;

    if (currentPath.length === 0) return; // already at root

    const newPath = currentPath.slice(0, -1);

    this.setState({ currentPath: newPath }, async () => {
      const folderNodeId = this.getCurrentFolderNodeId();
      await this.loadContents(folderNodeId);
    });
  };

  handleFolderToggle = (pathStr) => {
    this.setState((prevState) => {
      const isExpanded = prevState.expandedFolders.includes(pathStr);
      const expandedFolders = isExpanded
        ? prevState.expandedFolders.filter((f) => f !== pathStr)
        : [...prevState.expandedFolders, pathStr];

      return { expandedFolders };
    });
  };

  handleBreadcrumbClick = async (index) => {
    const newPath = this.state.currentPath.slice(0, index + 1);
    this.setState({ currentPath: newPath }, async () => {
      // Determine folder name to load
      const folderName = newPath[newPath.length - 1] || this.state.rootFolder;

      // Find fileNodeId for the folder
      let folderNodeId = null;
      Object.values(this.state.fileStructure)
        .flat()
        .forEach((item) => {
          if (item.name === folderName && item.type === 'folder') {
            folderNodeId = item.fileNodeId;
          }
        });

      await this.loadContents(folderNodeId, folderName);
    });
  };

  handleGridRightClick = (event, item, path) => {
    event.preventDefault();
    this.setState({
      contextMenuPosition: {
        top: event.clientY,
        left: event.clientX,
      },
      contextGridMenuAnchor: event.currentTarget,
      contextMenuTarget: item,
      contextMenuTargetPath: path,
    });
  };

  handleRightClick = (event, item, path) => {
    event.preventDefault();
    this.setState({
      contextMenuAnchor: event.currentTarget,
      contextMenuTarget: item,
      contextMenuTargetPath: path,
    });
  };

  handleCreateFolder = async () => {
    const name = this.state.newFolderName.trim();
    if (!name) return;

    const { currentPath, fileStructure, rootFolder } = this.state;

    try {
      let currentFolderName = rootFolder;
      let currentContents = fileStructure[currentFolderName] || [];
      let parentId = this.state.parentId;

      // Traverse down the currentPath
      for (let i = 0; i < currentPath.length; i++) {
        const folderName = currentPath[i];
        const found = currentContents.find(
          (item) => item.name === folderName && item.type === 'folder'
        );

        if (!found) {
          console.error(
            `Folder "${folderName}" not found under "${currentFolderName}"`
          );
          break;
        }

        parentId = found.fileNodeId;
        currentFolderName = folderName;
        currentContents = fileStructure[currentFolderName] || [];
      }

      // Send request to backend
      const response = await this.createFolder(parentId, name);

      if (response && response.success) {
        // Add the new folder to flat structure
        const newFolder = {
          fileNodeId: response.folder.fileNodeId,
          name: response.folder.name,
          type: response.folder.type,
          parentId: parentId,
          parentName: currentFolderName,
        };

        const updatedStructure = {
          ...fileStructure,
          [currentFolderName]: [
            ...(fileStructure[currentFolderName] || []),
            newFolder,
          ],
        };

        // Update state
        this.setState({
          showFolderDialog: false,
          newFolderName: '',
          fileStructure: updatedStructure,
        });
      } else {
        this.openFeedbackBar(
          'error',
          `${this.state.newFolderName} ` +
            (response?.message || 'Unknown error')
        );
        this.setState({ showFolderDialog: false, newFolderName: '' });
      }
    } catch (error) {
      this.setState({ showFolderDialog: false, newFolderName: '' });
      this.openFeedbackBar('error', 'Error creating folder: ' + error.message);
    }
  };

  handleFileDrop = (e) => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    const { fileStructure, rootFolder } = this.state;
    const newStructure = JSON.parse(JSON.stringify(fileStructure));
    let pointer = newStructure[rootFolder];

    const allowedTypes = [
      'image/jpeg',
      'image/png',
      'image/gif',
      'application/pdf',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // Excel
      'application/vnd.ms-excel', // Older Excel formats
      'application/msword', // Word
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // Word (docx)
      'text/csv', // CSV
    ];

    for (let file of files) {
      if (allowedTypes.includes(file.type)) {
        pointer[file.name] = null; // Add the file to the current folder if it's allowed
      } else {
        console.warn(`File type not allowed: ${file.name}`);
      }
    }

    this.setState({ fileStructure: newStructure });
  };

  handleRightFolderClick = (folderName, fileNodeId) => {
    this.setState(
      { currentPath: [...this.state.currentPath, folderName] },
      async () => {
        await this.loadContents(fileNodeId);
      }
    );
  };

  handleFolderClick = async (folderPathArray) => {
    const pathStr = folderPathArray.join('/');
    const currentPathStr = this.state.currentPath.join('/');

    if (pathStr === currentPathStr) return;

    const folderName = folderPathArray[folderPathArray.length - 1];

    if (this.state.currentPath.includes(folderName)) {
      const folderIndex = this.state.currentPath.indexOf(folderName);
      this.handleBreadcrumbClick(folderIndex);
      return;
    }

    const { fileStructure } = this.state;
    let folderNode = null;

    // Find folderNode from flat structure
    Object.values(fileStructure)
      .flat()
      .forEach((item) => {
        if (item.name === folderName && item.type === 'folder') {
          folderNode = item;
        }
      });

    if (!folderNode) {
      console.warn('Folder not found:', folderName);
      return;
    }

    this.handleRightFolderClick(folderName, folderNode.fileNodeId);
  };

  goToPath = (pathArray) => {
    const { folderHistory, historyIndex } = this.state;
    const newHistory = folderHistory.slice(0, historyIndex + 1);
    newHistory.push(pathArray);

    this.setState({
      currentPath: pathArray,
      folderHistory: newHistory,
      historyIndex: newHistory.length - 1,
    });
  };

  renderFolderTree = (items = [], path = []) => {
    if (!Array.isArray(items)) return null;

    return items
      .filter((item) => item.type === 'folder') // Only keep folders
      .map((item) => {
        const key = item.name;
        const fullPath = [...path, key];
        const pathStr = fullPath.join('/');
        const isExpanded = this.state.expandedFolders.includes(pathStr);
        const hasChildren = item.children && item.children.length > 0;

        return (
          <div key={pathStr}>
            <ListItem
              button
              onClick={() => {
                this.handleFolderToggle(pathStr);
                this.handleFolderClick(fullPath);
              }}
              style={{ paddingLeft: path.length * 16 }}
            >
              <ListItemIcon>
                <Folder />
              </ListItemIcon>
              <ListItemText primary={key} />
              {hasChildren && (isExpanded ? <ExpandLess /> : <ExpandMore />)}
            </ListItem>

            {hasChildren && (
              <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                {this.renderFolderTree(item.children, fullPath)}
              </Collapse>
            )}
          </div>
        );
      });
  };

  renderBreadcrumbs = () => {
    const { rootFolder, currentPath } = this.state;

    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Breadcrumbs separator="/" style={{ marginBottom: 16 }}>
          <Typography
            color={currentPath.length === 0 ? 'textPrimary' : 'inherit'}
            style={{ cursor: currentPath.length === 0 ? 'default' : 'pointer' }}
            onClick={() => currentPath.length > 0 && this.goToPath([])}
          >
            {rootFolder}
          </Typography>
          {currentPath.map((folder, i) => (
            <Typography
              key={i}
              color={i === currentPath.length - 1 ? 'textPrimary' : 'inherit'}
              style={{
                cursor: i !== currentPath.length - 1 ? 'pointer' : 'default',
              }}
              onClick={() =>
                i !== currentPath.length - 1 && this.handleBreadcrumbClick(i)
              }
            >
              {folder}
            </Typography>
          ))}
        </Breadcrumbs>
      </div>
    );
  };

  handleContextMenuClick = (event, target) => {
    event.stopPropagation(); // Prevent triggering other click handlers
    this.setState({
      contextMenuAnchor: event.currentTarget,
      contextMenuTarget: target, // store the file or folder name
    });
  };

  handleContextClose = () => {
    this.setState({ contextMenuAnchor: null, contextMenuTarget: null });
  };

  handleGridContextClose = () => {
    this.setState({ contextGridMenuAnchor: null, contextMenuTarget: null });
  };

  //cut/paste

  closeContextMenu = () => {
    this.setState({
      contextMenuAnchor: null,
      contextMenuTarget: null,
    });
  };

  handleCopy = () => {
    const { contextMenuTarget, currentPath, fileStructure, rootFolder } =
      this.state;

    try {
      let currentFolderName = rootFolder;
      let currentContents = fileStructure[currentFolderName] || [];

      // Traverse to the correct folder path
      for (let i = 0; i < currentPath.length; i++) {
        const folderName = currentPath[i];
        const found = currentContents.find(
          (item) => item.name === folderName && item.type === 'folder'
        );

        if (!found) {
          console.error(
            `Folder "${folderName}" not found under "${currentFolderName}"`
          );
          return;
        }

        currentFolderName = folderName;
        currentContents = fileStructure[currentFolderName] || [];
      }

      // Locate the item to copy using fileNodeId
      const itemToCopy = currentContents.find(
        (item) => item.fileNodeId === contextMenuTarget.fileNodeId
      );
      if (!itemToCopy) {
        console.error('Item to copy not found:', contextMenuTarget);
        return;
      }

      // Create a deep clone so changes don’t affect original
      const clonedItem = JSON.parse(JSON.stringify(itemToCopy));

      this.setState({
        clipboardAction: 'copy',
        clipboardItem: clonedItem,
      });
    } catch (error) {
      console.error('Error in handleCopy:', error);
    }

    this.closeContextMenu();
  };

  handleDuplicate = () => {
    const { contextMenuTarget, currentPath, fileStructure, rootFolder } =
      this.state;

    if (!contextMenuTarget || contextMenuTarget.type !== 'folder') {
      this.openFeedbackBar('error', 'Please select a folder to duplicate.');
      return;
    }

    // Find parent folder id
    let parentId = this.state.parentId; // root parent
    let currentContents = fileStructure[rootFolder] || [];
    let currentFolderName = rootFolder;

    for (let i = 0; i < currentPath.length; i++) {
      const folderName = currentPath[i];
      const found = currentContents.find(
        (item) => item.name === folderName && item.type === 'folder'
      );

      if (!found) break;

      parentId = found.fileNodeId;
      currentFolderName = folderName;
      currentContents = fileStructure[currentFolderName] || [];
    }

    this.props.apiRequest({
      key: 'fileManager/duplicate',
      endpoint: FOLDER.DUPLICATE_FOLDER,
      data: {
        folderId: contextMenuTarget.fileNodeId,
        parentId: parentId,
      },
      silent: true,
      onSuccess: (payload) => {
        if (payload?.success) {
          this.openFeedbackBar('success', 'Folder duplicated successfully!');
          const folderNodeId = this.getCurrentFolderNodeId();
          this.loadContents(folderNodeId);
        } else {
          this.openFeedbackBar('error', payload?.message || 'Duplicate failed');
        }
      },
      onError: (err) =>
        this.openFeedbackBar('error', err || 'Duplicate failed'),
    });

    this.closeContextMenu();
  };

  handleCut = () => {
    let { contextMenuTarget, currentPath, fileStructure, rootFolder } =
      this.state;

    try {
      let currentFolderName = rootFolder;
      let currentContents = fileStructure[currentFolderName] || [];

      // Traverse to the correct folder path
      for (let i = 0; i < currentPath.length; i++) {
        const folderName = currentPath[i];
        const found = currentContents.find(
          (item) => item.name === folderName && item.type === 'folder'
        );

        if (!found) {
          console.error(
            `Folder "${folderName}" not found under "${currentFolderName}"`
          );
          return;
        }

        //parentId = found.fileNodeId;
        currentFolderName = folderName;
        currentContents = fileStructure[currentFolderName] || [];
      }

      // Locate the item to cut using fileNodeId
      const itemToCut = currentContents.find(
        (item) => item.fileNodeId === contextMenuTarget.fileNodeId
      );
      if (!itemToCut) {
        console.error('Item to cut not found:', contextMenuTarget);
        return;
      }

      // Remove item from current folder
      const updatedContents = currentContents.filter(
        (item) => item.fileNodeId !== contextMenuTarget.fileNodeId
      );

      // Update fileStructure
      const newStructure = {
        ...fileStructure,
        [currentFolderName]: updatedContents,
      };

      this.setState({
        clipboardAction: 'cut',
        clipboardItem: itemToCut,
        fileStructure: newStructure,
      });
    } catch (error) {
      console.error('Error in handleCut:', error);
    }

    this.closeContextMenu();
  };

  renameNode = (id, newName) => {
    this.props.apiRequest({
      key: 'fileManager/renameNode',
      endpoint: FOLDER.RENAME_NODE,
      data: { id, newName },
      silent: true,
      onSuccess: (payload) => {
        if (payload?.success) {
          this.openFeedbackBar('success', 'Renamed successfully');
          const folderNodeId = this.getCurrentFolderNodeId();
          this.loadContents(folderNodeId); // refresh folder contents
        } else {
          this.openFeedbackBar('error', payload?.message || 'Rename failed');
        }
      },
      onError: (err) =>
        this.openFeedbackBar('error', 'Error: ' + (err || 'Rename failed')),
    });
  };

  handlePaste = () => {
    const {
      clipboardAction,
      clipboardItem,
      currentPath,
      rootFolder,
      fileStructure,
    } = this.state;

    let currentFolderName = rootFolder;
    let currentContents = fileStructure[currentFolderName] || [];
    let parentId = this.state.parentId;

    for (let i = 0; i < currentPath.length; i++) {
      const itemName = currentPath[i];
      const found = currentContents.find((item) => item.name === itemName);

      if (!found) {
        break;
      }

      parentId = found.fileNodeId;
      currentFolderName = itemName;
      currentContents = fileStructure[currentFolderName] || [];
    }

    if (!clipboardItem || !clipboardAction) return;

    this.props.apiRequest({
      key: 'fileManager/paste',
      endpoint: FOLDER.PASTE_ITEM,
      data: {
        action: clipboardAction,
        itemId: clipboardItem.fileNodeId,
        targetPath: parentId,
      },
      silent: true,
      onSuccess: (payload) => {
        if (payload?.success) {
          this.setState({
            clipboardItem: null,
            clipboardAction: null,
          });
          this.handleGridContextClose();
          this.loadContents(parentId);
        } else {
          this.openFeedbackBar('error', 'Error: ' + (payload?.message || 'paste failed'));
        }
      },
      onError: (err) =>
        this.openFeedbackBar('error', 'Error: ' + (err || 'paste failed')),
    });
  };

  handleBack = () => {
    this.setState({ previewOpen: false, selectedFile: null });
  };

  uploadFile = (file, onProgress) => {
    return new Promise((resolve, reject) => {
      const { currentPath, fileStructure, rootFolder } = this.state;

      let parentFolderName =
        currentPath.length === 0
          ? rootFolder
          : currentPath[currentPath.length - 1];

      let currentFolderName = rootFolder;
      let currentContents = fileStructure[currentFolderName] || [];
      let parentId = this.state.parentId;

      // Traverse down the currentPath
      for (let i = 0; i < currentPath.length; i++) {
        const folderName = currentPath[i];
        const found = currentContents.find(
          (item) => item.name === folderName && item.type === 'folder'
        );

        if (!found) {
          console.error(
            `Folder "${folderName}" not found under "${currentFolderName}"`
          );
          break;
        }

        parentId = found.fileNodeId;
        currentFolderName = folderName;
        currentContents = fileStructure[currentFolderName] || [];
      }

      const reader = new FileReader();

      reader.onload = (event) => {
        const base64DataUrl = event.target.result;
        const base64 = base64DataUrl.split(',')[1];

        // Routed through the generic api saga; passing `onProgress` makes
        // the saga use AuthUtil.postUploadRequest so axios's
        // onUploadProgress fires for the percent callback.
        this.props.apiRequest({
          key: `fileManager/upload/${file.name}`,
          endpoint: FOLDER.UPLOAD_FILE,
          data: {
            parentId: parentId,
            name: file.name,
            mimeType: file.type,
            size: file.size,
            bytes: base64,
          },
          onProgress,
          silent: true,
          onSuccess: (payload) => {
            if (payload?.success) {
              // Update frontend file structure
              const newFile = {
                fileNodeId: payload.file.fileNodeId,
                name: payload.file.name,
                type: payload.file.type,
                url: payload.file.url,
                path: payload.file.path,
                parentId: parentId,
                parentName: parentFolderName,
              };

              const allItems = Object.values(fileStructure).flat();
              allItems.push(newFile);

              const updatedStructure = allItems.reduce((acc, item) => {
                const parentName = item.parentName || rootFolder;
                if (!acc[parentName]) acc[parentName] = [];
                acc[parentName].push(item);
                return acc;
              }, {});

              this.setState({
                fileStructure: updatedStructure,
              });

              resolve(payload);
            } else {
              this.openFeedbackBar('error', payload?.message || 'Unknown error');
              reject(new Error(payload?.message || 'Upload failed'));
            }
          },
          onError: (err) => {
            this.openFeedbackBar('error', 'Upload failed: ' + (err || 'Unknown error'));
            reject(new Error(err || 'Upload failed'));
          },
        });
      };

      reader.onerror = (err) => {
        reject(err);
      };

      reader.readAsDataURL(file);
    });
  };

  createFolder = (parentId, name) => {
    return new Promise((resolve) => {
      this.props.apiRequest({
        key: `fileManager/createFolder/${name}`,
        endpoint: FOLDER.CREATE_FOLDER,
        data: { parentId, name },
        silent: true,
        onSuccess: (payload) => resolve(payload),
        onError: (err) => {
          this.openFeedbackBar(
            'error',
            'Error creating folder: ' + (err || 'unknown'),
          );
          resolve(null);
        },
      });
    });
  };

  loadContents = async (fileNodeId = null, folderName = null) => {
    const folderId = fileNodeId || this.state.parentId;

    try {
      const contentData = await this.listContents(folderId);

      if (!contentData) return;

      const nameToUse =
        folderName ||
        this.state.currentPath.slice(-1)[0] ||
        this.state.rootFolder;

      const updatedStructure = {
        ...this.state.fileStructure,
        [nameToUse]: contentData[nameToUse] || [],
      };

      this.setState({ fileStructure: updatedStructure });
    } catch (err) {
      this.openFeedbackBar(
        'error',
        'Error: ' + (err?.message || err.toString())
      );
    }
  };

  listContents = (folderId) => {
    return new Promise((resolve) => {
      this.props.apiRequest({
        key: `fileManager/list/${folderId}`,
        endpoint: FOLDER.LIST,
        data: { id: folderId },
        silent: true,
        onSuccess: (payload) => {
          if (payload?.success) {
            const flatList = payload.list;
            const grouped = {};
            flatList.forEach((item) => {
              if (!grouped[item.parentName]) {
                grouped[item.parentName] = [];
              }
              grouped[item.parentName].push(item);
            });
            resolve(grouped);
          } else {
            console.error('Failed to load structure:', payload?.message);
            resolve(undefined);
          }
        },
        onError: (err) => {
          console.error('Error listing contents:', err);
          resolve(undefined);
        },
      });
    });
  };

  buildLeftTree = (parentId) => {
    const fileStructureObj = this.state.fileStructure;

    if (!fileStructureObj || typeof fileStructureObj !== 'object') return [];

    const itemsArray = fileStructureObj[this.state.rootFolder] || [];

    const items = itemsArray.filter((item) => item.parentId === parentId);

    return items.map((item) => ({
      ...item,
      children: this.buildLeftTree(item.fileNodeId),
    }));
  };

  downloadFile = async () => {
      const { selectedFile } = this.state;

      if (!selectedFile?.name || !selectedFile?.path) {
          this.openFeedbackBar('error', 'File not found');
          return;
      }

      const name = selectedFile.name;


     const downloadUrl = `${BASE_URL}/folder/download?path=${encodeURIComponent(selectedFile.path)}`;


      try {
          const token = localStorage.getItem('token'); // 👈 wherever you store it

          const response = await fetch(downloadUrl, {
              method: 'GET',
              headers: {
                  'Authorization': `Bearer ${token}`,  // 👈 pass it here
              },
          });

          if (!response.ok) throw new Error(`Download failed (${response.status})`);

          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = name;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);

          this.openFeedbackBar('success', 'Download started');
      } catch (err) {
          console.error(err);
          this.openFeedbackBar('error', err.message || 'Download failed');
      }
  };

  openSearchResult = async (item) => {
    // Build correct breadcrumb path
    const path = item.fullPath.map((p) => p.name);

    if (item.type === 'folder') {
      this.setState({
        currentPath: path.slice(1), // remove root
        searchText: '',
        searchResults: [],
      });
      await this.loadContents(item.fileNodeId, item.name);
    } else {
      const parentPath = path.slice(1, -1);

      this.setState({
        currentPath: parentPath,
        searchText: '',
        searchResults: [],
      });

      await this.loadContents(item.parentId);
      this.handleFileClick(item);
    }
  };

  getCurrentFolderNodeId = () => {
    const currentFolderName = this.state.currentPath.length
      ? this.state.currentPath[this.state.currentPath.length - 1]
      : this.state.rootFolder;

    // If current folder is the root folder
    if (currentFolderName === this.state.rootFolder) return this.state.parentId;

    // Search the parent folder for the current folder
    for (let folderListName in this.state.fileStructure) {
      const items = this.state.fileStructure[folderListName] || [];
      const folder = items.find(
        (item) => item.name === currentFolderName && item.type === 'folder'
      );
      if (folder) return folder.fileNodeId;
    }

    return this.state.parentId; // fallback
  };

  handleDelete = () => {
    const { contextMenuTarget } = this.state;
    if (!contextMenuTarget?.fileNodeId) return;

    const targetId = contextMenuTarget.fileNodeId;

    this.setState({
      contextMenuAnchor: null,
      contextGridMenuAnchor: null,
      contextMenuTarget: null,
    });

    this.props.apiRequest({
      key: 'fileManager/delete',
      endpoint: FOLDER.DELETE_TEMPORARY_NODE,
      data: { id: targetId },
      silent: true,
      onSuccess: (payload) => {
        if (payload?.success) {
          this.openFeedbackBar('success', 'Moved to Recycle Bin');
          // Refresh the current folder properly
          const folderNodeId = this.getCurrentFolderNodeId();
          const currentFolderName = this.state.currentPath.length
            ? this.state.currentPath[this.state.currentPath.length - 1]
            : this.state.rootFolder;
          this.loadContents(folderNodeId, currentFolderName);
        } else {
          this.openFeedbackBar('error', payload?.message || 'Delete failed');
        }
      },
      onError: (err) => this.openFeedbackBar('error', 'Error: ' + (err || 'delete failed')),
    });
  };

  render() {
    const currentFolderName = this.state.currentPath.length
      ? this.state.currentPath[this.state.currentPath.length - 1]
      : this.state.rootFolder;

    // Get the current folder's contents from fileStructure
    const currentContents = this.state.fileStructure[currentFolderName] || [];

    // Separate folders and files
    const folders = currentContents.filter((item) => item.type === 'folder');
    const files = currentContents.filter((item) => item.type !== 'folder');

    // Hive ownership model: files live in the user's own Space (enforced
    // server-side by FolderService space-membership checks), so anyone who can
    // open the Document Center has full control of their own files. The legacy
    // per-user edit-access / delete-access / admin-only-recycle route gates are
    // retired — everyone gets create / upload / rename / delete / recycle.
    const canEdit = true;
    const canDelete = true;
    const canRecycle = true;

    let headerButtons = [];

    if (this.state.previewOpen) {
      headerButtons.push(
        {
          icon: <KeyboardBackspaceIcon />,
          handler: this.handleBack,
          title: 'Go back to dashboard',
        },
        ...(canEdit
          ? [
              {
                icon: <DownloadIcon />,
                handler: this.downloadFile,
                title: 'Download',
              },
            ]
          : [])
      );
    } else if (this.state.showRecycleBin) {
      // Recycle Bin: show only back button to go back
      headerButtons.push({
        icon: <KeyboardBackspaceIcon />,
        handler: () =>
          this.setState({ showRecycleBin: false }, async () => {
            // Refresh the current folder properly
            const folderNodeId = this.getCurrentFolderNodeId();
            const currentFolderName = this.state.currentPath.length
              ? this.state.currentPath[this.state.currentPath.length - 1]
              : this.state.rootFolder;

            await this.loadContents(folderNodeId, currentFolderName);
          }),
        title: 'Back',
      });
    } else {
      headerButtons.push(
        {
          icon: <HomeIcon />,
          handler: this.props.history.goBack,
          title: 'Go back to dashboard',
        },

        ...(this.state.currentPath.length > 0
      ? [
          {
            icon: <KeyboardBackspaceIcon />,
            handler: this.goBack,
            title: 'Go back',
          },
        ]
      : []),

        ...(canEdit
          ? [
              {
                icon: <CreateNewFolderIcon />,
                handler: () =>
                  this.setState({
                    showFolderDialog: true,
                    newFolderName: '',
                    renameTarget: null,
                  }),
                title: 'Create Folder',
              },
            ]
          : []),

        ...(canEdit
          ? [
              {
                icon: <FileUpload />,
                handler: () => this.setState({ showUploadDialog: true }),
                title: 'Upload file',
              },
            ]
          : []),

        ...(canRecycle
          ? [
              {
                icon: <RecyclingIcon />,
                handler: () => this.setState({ showRecycleBin: true }),
                title: 'Recycle Bin',
              },
            ]
          : [])
      );
    }

    return (
      <>
        <CustomToolbar
          title={
            this.state.showRecycleBin
              ? 'Recycle Bin'
              : this.state.previewOpen && this.state.selectedFile?.name
              ? this.state.selectedFile.name
              : ``
          }
          createTitle={'File Manager'}
          backTitle={'Back To Menu'}
          onClick={() => {}}
          headerButtons={headerButtons}
        />

        <FeedbackBar
          open={this.state.feedbackBarOpen}
          handleClose={this.closeFeedbackBar}
          severity={this.state.feedbackStatus}
          message={this.state.feedbackMessage}
        />

        {this.state.previewOpen ? (
          <>
            <PreviewModal
              open={this.state.previewOpen}
              onClose={this.handleClosePreview}
              file={this.state.selectedFile || {}}
            />
          </>
        ) : this.state.showRecycleBin ? (
          <RecycleBin
            parentId={this.state.parentId}
            onBack={() => this.setState({ showRecycleBin: false })}
          />
        ) : (
          <Grid
            container
            style={{ height: '100vh', backgroundColor: '#f4f6f8' }}
          >
            {/* Right Panel: File List */}
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              style={{
                overflowY: 'auto',
                height: '100vh',
                width: '100%',
                padding: 0,
              }}
              onContextMenu={this.handleGridRightClick}
            >
              <div style={{ padding: 16, marginTop: '8px' }}>
                <TextField
                  style={{ marginBottom: '16px' }}
                  className="custom-search"
                  margin="dense"
                  label="Search files or folders"
                  variant="outlined"
                  fullWidth
                  value={this.state.searchText}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          className="clear-button"
                          onClick={() =>
                            this.setState({ searchText: '', searchResults: [] })
                          }
                        >
                          <Clear />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  onChange={(e) =>
                    this.setState({ searchText: e.target.value })
                  }
                  onBlur={this.handleGlobalSearch}
                />

                {this.renderBreadcrumbs()}

                <Grid
                  container
                  spacing={3}
                  onDrop={this.handleFileDrop}
                  onDragOver={(e) => e.preventDefault()}
                >
                  {/*//upload a file*/}
                  <UploadFileDialog
                    open={this.state.showUploadDialog}
                    onClose={() => this.setState({ showUploadDialog: false })}
                    onUpload={(file, onProgress) =>
                      this.uploadFile(file, onProgress)
                    }
                  />

                  {/* Create Folder Dialog */}

                  <Dialog
                    fullWidth
                    maxWidth="sm"
                    open={this.state.showFolderDialog}
                    onClose={() =>
                      this.setState({
                        showFolderDialog: false,
                        newFolderName: '',
                        renameTarget: null,
                      })
                    }
                    TransitionProps={{
                      // Focus the input *after* the dialog transition completes
                      // so the OS opens the on-screen keyboard automatically.
                      // Pre-select the existing text on rename so typing
                      // replaces it.
                      onEntered: () => {
                        if (this.folderNameInput) {
                          this.folderNameInput.focus();
                          if (this.state.renameTarget) {
                            this.folderNameInput.select();
                          }
                        }
                      },
                    }}
                  >
                    <DialogTitle style={{ marginLeft: '-16px' }}>
                      {this.state.renameTarget ? 'Rename' : 'Create New Folder'}
                    </DialogTitle>

                    <DialogContent
                      style={{
                        marginLeft: '-16px',
                        marginRight: '-16px',
                        marginBottom: '8px',
                      }}
                    >
                      <TextField
                        label={
                          this.state.renameTarget ? 'New Name' : 'Folder Name'
                        }
                        fullWidth
                        variant="outlined"
                        autoFocus
                        inputRef={(el) => { this.folderNameInput = el; }}
                        value={this.state.newFolderName}
                        onChange={(e) =>
                          this.setState({ newFolderName: e.target.value })
                        }
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' && this.state.newFolderName.trim()) {
                            e.preventDefault();
                            this.handleFolderDialogConfirm();
                          }
                        }}
                      />
                    </DialogContent>

                    <DialogActions
                      style={{ marginBottom: '8px', marginRight: '16px' }}
                    >
                      <Button
                        variant="contained"
                        onClick={() =>
                          this.setState({
                            showFolderDialog: false,
                            newFolderName: '',
                            renameTarget: null,
                          })
                        }
                      >
                        Cancel
                      </Button>

                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleFolderDialogConfirm}
                      >
                        {this.state.renameTarget ? 'Rename' : 'Create'}
                      </Button>
                    </DialogActions>
                  </Dialog>

                  {this.state.searchResults.length > 0 ? (
                    <Paper
                      style={{
                        marginTop: 8,
                        marginLeft: 16,
                        maxHeight: 400,
                        overflowY: 'auto',
                        position: 'relative',
                        zIndex: 10,
                      }}
                    >
                      {this.state.searchResults.map((item) => (
                        <ListItem
                          button
                          key={item.fileNodeId}
                          onClick={() => this.openSearchResult(item)}
                        >
                          <ListItemIcon>
                            {item.type === 'folder' ? (
                              <Folder />
                            ) : (
                              <InsertDriveFile />
                            )}
                          </ListItemIcon>

                          <ListItemText
                            primary={item.name}
                            secondary={item.fullPath
                              .map((p) => p.name)
                              .join(' / ')}
                          />
                        </ListItem>
                      ))}
                    </Paper>
                  ) : (
                    <>
                      {folders.map((folder) => (
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={2}
                          key={folder.fileNodeId}
                        >
                          <Paper
                            style={{
                              padding: 16,
                              position: 'relative',
                              cursor: 'pointer',
                              textAlign: 'center',
                              boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                              borderRadius: 8,
                              transition: 'all 0.3s ease',
                            }}
                            onClick={() =>
                              this.handleRightFolderClick(
                                folder.name,
                                folder.fileNodeId
                              )
                            }
                            onContextMenu={(e) =>
                              this.handleRightClick(e, folder, folder.name)
                            }
                          >
                            <IconButton
                              size="small"
                              style={{ position: 'absolute', top: 4, right: 4 }}
                              onClick={(e) =>
                                this.handleContextMenuClick(e, folder)
                              }
                            >
                              <MoreVertIcon />
                            </IconButton>
                            <Folder
                              style={{ fontSize: 40, color: '#3f51b5' }}
                            />
                            <Typography
                              variant="body2"
                              style={{
                                marginTop: 8,
                                color: '#333',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                textAlign: 'center',
                                whiteSpace: 'pre-line',
                                maxWidth: '100%',
                                display: 'block',
                              }}
                            >
                              {folder.name}
                            </Typography>
                          </Paper>
                        </Grid>
                      ))}

                      {/* Render Files */}
                      {files.map((file) => (
                        <Grid item xs={12} sm={6} md={2} key={file.fileNodeId}>
                          <Paper
                            style={{
                              padding: 16,
                              cursor: 'pointer',
                              position: 'relative',
                              textAlign: 'center',
                              boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                              borderRadius: 8,
                              transition: 'all 0.3s ease',
                            }}
                            onClick={() => this.handleFileClick(file)}
                            onContextMenu={(e) =>
                              this.handleRightClick(e, file, file.name)
                            }
                          >
                            <IconButton
                              size="small"
                              style={{ position: 'absolute', top: 4, right: 4 }}
                              onClick={(e) =>
                                this.handleContextMenuClick(e, file)
                              }
                            >
                              <MoreVertIcon />
                            </IconButton>
                            <InsertDriveFile
                              style={{ fontSize: 40, color: '#757575' }}
                            />
                            <Typography
                              variant="body2"
                              style={{
                                marginTop: 8,
                                color: '#333',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                maxWidth: '100%',
                                display: 'block',
                              }}
                            >
                              {file.name}
                              {/*{file}*/}
                            </Typography>
                          </Paper>
                        </Grid>
                      ))}
                    </>
                  )}
                </Grid>
              </div>
            </Grid>

            {/* Context Menu */}
            <Menu
              style={{ marginTop: '16px' }}
              anchorEl={this.state.contextMenuAnchor}
              open={Boolean(this.state.contextMenuAnchor)}
              onClose={this.handleContextClose}
              keepMounted
            >
              {/*/!* ✅ Copy – EDIT only *!/*/}
              {/*{canEdit && (*/}
              {/*    <MenuItem onClick={this.handleCopy}>*/}
              {/*      <ListItemIcon><ContentCopy /></ListItemIcon>*/}
              {/*      <ListItemText primary="Copy" />*/}
              {/*    </MenuItem>*/}
              {/*)}*/}

              {/*/!* ✅ Cut – EDIT only *!/*/}
              {/*{canEdit && (*/}
              {/*    <MenuItem onClick={this.handleCut}>*/}
              {/*      <ListItemIcon><ContentCut /></ListItemIcon>*/}
              {/*      <ListItemText primary="Cut" />*/}
              {/*    </MenuItem>*/}
              {/*)}*/}

              {/* ✅ Duplicate – Duplicate only with sub folders not files*/}
              {canEdit && (
                <MenuItem onClick={this.handleDuplicate}>
                  <ListItemIcon>
                    <ContentCopy />
                  </ListItemIcon>
                  <ListItemText primary="Duplicate" />
                </MenuItem>
              )}

              {canEdit && (
                <MenuItem
                  onClick={() =>
                    this.openRenameDialog(this.state.contextMenuTarget)
                  }
                >
                  <ListItemIcon>
                    <DriveFileRenameOutline />
                  </ListItemIcon>
                  <ListItemText primary="Rename" />
                </MenuItem>
              )}

              {/* ✅ Delete – DELETE only */}
              {canDelete && (
                <MenuItem onClick={this.handleDelete}>
                  <ListItemIcon>
                    <Delete />
                  </ListItemIcon>
                  <ListItemText primary="Delete" />
                </MenuItem>
              )}
            </Menu>

            {/*//grid menu*/}
            {/*  <Menu*/}
            {/*  anchorReference="anchorPosition"*/}
            {/*  anchorPosition={*/}
            {/*    this.state.contextMenuPosition*/}
            {/*      ? {*/}
            {/*          top: this.state.contextMenuPosition.top,*/}
            {/*          left: this.state.contextMenuPosition.left,*/}
            {/*        }*/}
            {/*      : undefined*/}
            {/*  }*/}
            {/*  anchorEl={this.state.contextGridMenuAnchor}*/}
            {/*  open={Boolean(this.state.contextGridMenuAnchor)}*/}
            {/*  onClose={this.handleGridContextClose}*/}
            {/*  keepMounted>*/}

            {/*    <MenuItem*/}
            {/*      onClick={this.handlePaste}*/}
            {/*      disabled={!this.state.clipboardItem}>*/}
            {/*      <ListItemIcon><ContentPaste /></ListItemIcon>*/}
            {/*      <ListItemText primary="Paste" />*/}
            {/*    </MenuItem>*/}

            {/*</Menu>*/}
          </Grid>
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  userInfo: userInfoSelector(state),
});


export default withShipment(
  {
    mapStateToProps,
    actionCreators: { apiRequest },
  },
  FileManager,
);
